import CustomError from '@/utils/custom-error';
import APIRequestService from './APIRequestService';

const request = new APIRequestService();

export const getSeriesListByFiduciaryId = (fiduciaryId) => {
  const url = `/fiduciaries/${fiduciaryId}/fund-series`;
  return request.get(url);
};

export const getSeriesListByClientId = (fiduciaryClientId) => {
  const url = `/fiduciary-clients/${fiduciaryClientId}/fund-series`;
  return request.get(url);
};

// HTTP request designed for both adding and removing fund (action: ['add', 'delete'])
export const modifyFundsInSeries = (fiduciaryClientId, selectedFunds, seriesId, action) => {
  // creating the url
  const url = `/fiduciary-clients/${fiduciaryClientId}/fund-series`;

  // creating the payload
  const payload = selectedFunds.map((fund) => {
    return {
      fundSeriesId: seriesId,
      fiduciaryFundId: fund.id,
      action,
    };
  });

  return request.post(url, { data: JSON.stringify(payload) });
};

// HTTP request designed for creating a new series for a fiduciary-client
export const createNewSeriesForFiduciaryClient = (fiduciaryClientId, seriesName) => {
  // creating the url
  const url = `/fiduciary-clients/${fiduciaryClientId}/fund-series-names`;

  // creating the payload
  const payload = {
    seriesName,
  };

  return request.post(url, { data: JSON.stringify(payload) });
};

// HTTP request designed for editing the given series for a fiduciary-client
export const editSeriesNameForFiduciaryClient = (fiduciaryClientId, seriesName, seriesId) => {
  // creating the url
  const url = `/fiduciary-clients/${fiduciaryClientId}/fund-series-names/${seriesId}`;

  // creating the payload
  const payload = {
    seriesName,
  };

  return request.post(url, { data: JSON.stringify(payload) });
};

export const getStrategyName = async (clientId, fundSecId) => {
  const url = `/fiduciary-clients/${clientId}/funds/${fundSecId}/fund-strategies`;
  try {
    const response = await request.get(url);
    if (Array.isArray(response.data) && response.data.length > 0) {
      return response.data[0];
    }
    return {};
  } catch (err) {
    throw new CustomError(err, err.message);
  }
};

export const getSeriesFundsList = (clientId, seriesId) => {
  const url = `/fiduciary-clients/${clientId}/fund-series/${seriesId}`;
  return request.get(url);
};

export const getAvailableFundsToAddToSeriesList = ({
  selectedClient,
  currentPage,
  queryOptions,
}) => {
  const url = `/fiduciary-clients/${selectedClient}/fund-series/funds?page=${currentPage}${queryOptions}`;
  return request.get(url);
};
